import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "m-auto py-3" }
const _hoisted_2 = { class: "m-auto px-8" }
const _hoisted_3 = { class: "grid grid-cols-12 mb-2 gap-2 pt-4" }
const _hoisted_4 = { class: "col-span-1 flex flex-col" }
const _hoisted_5 = { class: "col-span-2 flex flex-col mb-3" }
const _hoisted_6 = { class: "col-span-2 flex flex-col mb-3" }
const _hoisted_7 = { class: "relative inline-block p-2 group" }
const _hoisted_8 = { class: "mr-2 border border-next p-1" }
const _hoisted_9 = { class: "mr-1" }
const _hoisted_10 = { class: "col-span-2 flex flex-col mb-3" }
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = { class: "flex flex-col" }
const _hoisted_13 = { class: "col-span-3 flex flex-col" }
const _hoisted_14 = { class: "flex justify-end" }
const _hoisted_15 = { class: "rotate-x-180 overflow-x-scroll" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "px-2 bg-transparent border-b-2 border-b-next-gray-md-dark" }
const _hoisted_19 = { class: "px-2 bg-transparent text-right border-b-2 border-b-next-gray-md-dark" }
const _hoisted_20 = {
  colspan: "4",
  class: "px-2 bg-transparent border-b-2 border-b-next-gray-md-dark"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NextTable = _resolveComponent("NextTable")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, {
        visible: _ctx.loading||_ctx.listaPianoFatturazione.loading
      }, null, 8, ["visible"])
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[14] || (_cache[14] = _createElementVNode("h1", { class: "text-3xl font-bold" }, "Piano di fatturazione", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Field, { field_name: "Stato" }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  modelValue: _ctx.stato_filter,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.stato_filter) = $event)),
                  options: _ctx.stato_options,
                  placeholder: "Stato",
                  class: "next-vue-multiselect-single",
                  "track-by": "id",
                  label: "text",
                  selectLabel: "",
                  deselectLabel: "",
                  selectedLabel: "",
                  "internal-search": true,
                  "close-on-select": true,
                  "clear-on-select": true
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Field, { field_name: "Termini di pagamento" }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  modelValue: _ctx.terminiDiPagamentoAutocomplete.selection,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.terminiDiPagamentoAutocomplete.selection) = $event)),
                  options: _ctx.terminiDiPagamentoAutocomplete.options,
                  onSearchChange: _ctx.terminiDiPagamentoAutocomplete.search,
                  loading: _ctx.terminiDiPagamentoAutocomplete.isLoading,
                  placeholder: "Scegli termine di pagamento",
                  class: "next-vue-multiselect-single",
                  "track-by": "id",
                  label: "descrizione",
                  selectLabel: "",
                  deselectLabel: "",
                  selectedLabel: "",
                  "internal-search": true
                }, null, 8, ["modelValue", "options", "onSearchChange", "loading"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Field, { field_name: "Business unit" }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  searchable: true,
                  loading: _ctx.buAutocomplete.isLoading,
                  "internal-search": false,
                  trackBy: "id",
                  label: "nome",
                  onSearchChange: _ctx.buAutocomplete.search,
                  modelValue: _ctx.buAutocomplete.selection,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.buAutocomplete.selection) = $event)),
                  options: _ctx.buAutocomplete.options,
                  "close-on-select": true,
                  "clear-on-select": true,
                  class: "next-vue-multiselect-single",
                  placeholder: "Business Unit",
                  deselectLabel: "Deseleziona",
                  selectedLabel: "Selezionato",
                  selectLabel: "Seleziona"
                }, {
                  option: _withCtx(({option, props}) => [
                    _createElementVNode("span", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(option.label), 1),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(option.nome), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["loading", "onSearchChange", "modelValue", "options"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_Field, {
              field_name: "Cliente",
              placeholder: "Cliente"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  onSearchChange: _ctx.clienteAutocomplete.search,
                  loading: _ctx.clienteAutocomplete.isLoading,
                  options: _ctx.clienteAutocomplete.options,
                  modelValue: _ctx.clienteAutocomplete.selection,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.clienteAutocomplete.selection) = $event)),
                  "track-by": "id",
                  label: "denominazione",
                  class: "next-vue-multiselect-single",
                  placeholder: "Cliente",
                  deselectLabel: "Deseleziona",
                  selectedLabel: "Selezionato",
                  selectLabel: "Seleziona"
                }, {
                  noResult: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode("Nessun elemento trovato.")
                  ])),
                  singleLabel: _withCtx(({option}) => [
                    _createTextVNode(_toDisplayString(`${option.denominazione} - ${option.ragione_sociale}`), 1)
                  ]),
                  option: _withCtx(({option}) => [
                    _createTextVNode(_toDisplayString(`${option.denominazione} - ${option.ragione_sociale}`), 1)
                  ]),
                  _: 1
                }, 8, ["onSearchChange", "loading", "options", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_Field, {
              field_name: "Scadenza dal",
              type: "date",
              modelValue: _ctx.filtri.scadenza_dal,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filtri.scadenza_dal) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_Field, {
              field_name: "Scadenza al",
              type: "date",
              modelValue: _ctx.filtri.scadenza_al,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filtri.scadenza_al) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_Field, {
              modelValue: _ctx.listaPianoFatturazione.search,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.listaPianoFatturazione.search) = $event)),
              field_name: "Cerca",
              placeholder: "Cerca"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_Paginator, {
            pagination: _ctx.listaPianoFatturazione.paginate
          }, null, 8, ["pagination"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_NextTable, {
            class: "rotate-x-180 w-full border-separate border-spacing-3 pl-5 py-4 table-fixed",
            cols: _ctx.pianoDiFatturazioneCols,
            "onUpdate:cols": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.pianoDiFatturazioneCols) = $event)),
            pagination: _ctx.listaPianoFatturazione.paginate,
            rows: _ctx.listaPianoFatturazione.rows,
            onOrderUpdate: _ctx.listaPianoFatturazione.updateCols
          }, _createSlots({ _: 2 }, [
            _renderList(_ctx.listaPianoFatturazione.rows, (c, j) => {
              return {
                name: `td_${j}_0`,
                fn: _withCtx((context) => [
                  (context.context.row.righe.length != 0)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["table-curtain-icon absolute top-0 bottom-0 flex items-center px-3 group", {open: c.expanded}]),
                        onClick: ($event: any) => (c.expanded=!c.expanded)
                      }, _cache[10] || (_cache[10] = [
                        _createElementVNode("i", { class: "fas fa-caret-right text-xl group-hover:text-next-orange duration-300 ease-in-out" }, null, -1)
                      ]), 10, _hoisted_16))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(context.context.row.cod_nodo), 1)
                ])
              }
            }),
            _renderList(_ctx.listaPianoFatturazione.rows, (c, j) => {
              return {
                name: `td_${j}_3`,
                fn: _withCtx((context) => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toCurrency(_ctx.TotaleRighePianoDiFatturazione(c.righe))), 1)
                ])
              }
            }),
            _renderList(_ctx.listaPianoFatturazione.rows, (c, j) => {
              return {
                name: `td_${j}_5`,
                fn: _withCtx((context) => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toDate(c.data_emissione_fattura)), 1)
                ])
              }
            }),
            _renderList(_ctx.listaPianoFatturazione.rows, (c, j) => {
              return {
                name: `td_${j}_6`,
                fn: _withCtx(({context}) => [
                  _createTextVNode(_toDisplayString(context.row[context?.cell?.prop]) + " ", 1),
                  (context.row?.allegato_file_id)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: [
                          _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
                          ($event: any) => (_ctx.downloadFile(context.row?.allegato_file_id))
                        ],
                        class: "block underline text-sm text-next-atp whitespace-nowrap cursor-pointer"
                      }, " Scarica allegato ", 8, _hoisted_17))
                    : _createCommentVNode("", true)
                ])
              }
            }),
            _renderList(_ctx.listaPianoFatturazione.rows, (c, j) => {
              return {
                name: `td_${j}_7`,
                fn: _withCtx((context) => [
                  _createVNode(_component_router_link, {
                    to: {name:'SottoProgettoPianoFatturazione', params:{id:context.context.row.sottoprogetto_id}},
                    class: "text-center inset-0 absolute flex items-center justify-center"
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                    ])),
                    _: 2
                  }, 1032, ["to"])
                ])
              }
            }),
            _renderList(_ctx.listaPianoFatturazione.rows, (c, j) => {
              return {
                name: `td_child_${j}`,
                fn: _withCtx(({context}) => [
                  (c.expanded)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(context.row.righe, (cc, i) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: i,
                          class: "h-5 text-sm"
                        }, [
                          _cache[12] || (_cache[12] = _createElementVNode("td", {
                            colspan: "2",
                            class: "px-2 bg-transparent border-b-2 border-b-next-gray-md-dark"
                          }, null, -1)),
                          _createElementVNode("td", _hoisted_18, _toDisplayString(cc.iva.descrizione), 1),
                          _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(cc.valore))), 1),
                          _createElementVNode("td", _hoisted_20, _toDisplayString(cc.note), 1)
                        ]))
                      }), 128))
                    : _createCommentVNode("", true)
                ])
              }
            })
          ]), 1032, ["cols", "pagination", "rows", "onOrderUpdate"])
        ]),
        _createVNode(_component_InfiniteLoading, {
          onInfinite: _ctx.listaPianoFatturazione.fetchNextPage,
          identifier: _ctx.listaPianoFatturazione.infiniteIdentifier,
          style: {"min-height":"1px"}
        }, {
          complete: _withCtx(() => _cache[13] || (_cache[13] = [
            _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altri piani di fatturazione.", -1)
          ])),
          _: 1
        }, 8, ["onInfinite", "identifier"])
      ])
    ])
  ], 64))
}